module.exports = __webpack_public_path__ + "img/2020_11_15_frog.790f6874.jpg";